import { render, staticRenderFns } from "./fuwenben.vue?vue&type=template&id=0acee063&"
import script from "./fuwenben.vue?vue&type=script&lang=js&"
export * from "./fuwenben.vue?vue&type=script&lang=js&"
import style0 from "./fuwenben.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports